import { createSelector } from 'reselect';

export const getState = (state) => state.createListing;

export const getCreateListing = createSelector(getState, ({ listing }) => listing);
